import React from "react";
import ImageUploadFlow from "../ImageUploadFlow";

// Updates an organization's picture; the flow saves it under the org's private S3 folder
interface OrganizationImageUploadModalProps {
  asset: { id?: string; organizationId?: string; name?: string; imageUrl?: string | null };
  onClose?: (result?: any) => void;
}

const OrganizationImageUploadModal: React.FC<OrganizationImageUploadModalProps> = ({ asset, onClose }) => (
  <ImageUploadFlow
    asset={asset}
    onClose={onClose}
    uploadTarget="organization"
    title="Update Organization Picture"
  />
);

export default OrganizationImageUploadModal;
